/**
 * @generated SignedSource<<e6e5fe44b8ee51fed40e7eeb9934056f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButton_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedShoppingButton_user";
};
export type PdpSharedShoppingButton_user$key = {
  readonly " $data"?: PdpSharedShoppingButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButton_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9c87f7b9a6fbda7b4aa1920850edb6f4";

export default node;
